import nextAction from 'model/actions/utilities/nextAction';

const end = onDone => ({
  title: 'Long Tom',
  description: [
    'I approach cautiously. gun still at the ready.',
    'looking down at the bodies a mix of hatred and pity',
    'this is not the end. there are more of them',
    'I mount my horse'
  ],
  buttons: [nextAction('Continue', onDone)]
});

const tom = onDone => ({
  title: 'Long Tom',
  description: [
    'I turn to face Tom, who had struggled to his feet. his own revolver in hand',
    'we face each other across the dying fire,',
    'he fires first but I am ready. at the first twitch I dive for cover behind a rock',
    'he staggers as I fire back. my aim true. his weapon falls from his hand.'
  ],
  buttons: [nextAction('Approach', onDone(end(onDone)))]
});

const brothers = onDone => ({
  title: 'Long Tom',
  description: [
    'a shot rings out in the stillness of the night, and one of the brothers falls.',
    'his weapon clattering against the rocks',
    'the other brother draws his gun by my hand is quicker. ',
    'two more shots echo in the darkness as the second brother falls.'
  ],
  buttons: [nextAction('Continue', onDone(tom(onDone)))]
});

const search = onDone => ({
  title: 'Long Tom',
  description: [
    'I make out some of the writing',
    "\"...they taken the young'un with 'em but they gon' deliver my cut to me soon enough...\"",
    '...didn\'t spill all that blood jist to come away with nothin..."',
    "there is a name there too. 'Long Tom'.",
    'and the two shapes are the brothers I freed.',
    'they begin to stir. as they notice me they scramble for their guns.'
  ],
  buttons: [nextAction('Draw Gun', () => onDone(brothers(onDone)))]
});

const approach = onDone => ({
  title: 'Long Tom',
  description: [
    'a man. half propped against a rock. lanky. head tilted back. two other shapes curled nearby ',
    'as I draw near, I catch the glint of a map on the ground. same one I have been following.',
    'next to it, a letter. '
  ],
  buttons: [nextAction('Look closer', () => onDone(search(onDone)))]
});

const start = onDone => ({
  title: 'Long Tom',
  description: [
    "it's been many days of riding alone. no sign of people for miles",
    "suddenly - a plume of smoke on the horizon. coming from the direction I'm headed",
    'a dying fire by the side of the road. down to coals.',
    'I approach cautiously'
  ],
  buttons: [nextAction('Approach', () => onDone(approach(onDone)))]
});

export default start;
